import BaseEnumType from "../../common/base-enum-type";

const ParticipationStyle = Object.freeze({
    Default: new BaseEnumType("default", "Default"),
    Continuous: new BaseEnumType("continuous", "Continuous")
});

export default ParticipationStyle;
